import { createApp } from "vue";
import { Quasar, Dialog, Notify } from "quasar";
import quasarIconSet from "quasar/icon-set/fontawesome-v6";
import langFr from "quasar/lang/fr";
import * as Sentry from "@sentry/vue";

const SENTRY_RELEASE = import.meta.env.VITE_SENTRY_RELEASE;

// Import icon libraries
import "@quasar/extras/roboto-font/roboto-font.css";
import "@quasar/extras/fontawesome-v6/fontawesome-v6.css";

// Import Quasar css
import "quasar/src/css/index.sass";

// Assumes your root component is App.vue
// and placed in same folder as main.js
import App from "./App.vue";
import router from "./router";

const myApp = createApp(App);

window._env_.SENTRY_RELEASE = SENTRY_RELEASE;

if (window._env_.SENTRY_DSN) {
    Sentry.init({
        app: myApp,
        dsn: window._env_.SENTRY_DSN,
        environment: window._env_.SENTRY_ENVIRONMENT,
        release: SENTRY_RELEASE,
        integrations: [
            Sentry.browserTracingIntegration({ router }),
            Sentry.replayIntegration(),
        ],
        trackComponents: false,
        // Performance Monitoring
        tracesSampleRate: window._env_.SENTRY_TRACES_SAMPLE_RATE,
        // Session Replay
        replaysSessionSampleRate: window._env_.SENTRY_REPLAYS_SAMPLE_RATE,
        replaysOnErrorSampleRate: 1.0,
    });
}

myApp.use(router);

myApp.use(Quasar, {
    plugins: { Dialog, Notify }, // import Quasar plugins and add here
    iconSet: quasarIconSet,
    lang: langFr,
});

// Assumes you have a <div id="app"></div> in your index.html
myApp.mount("#app");
